module.exports = __webpack_public_path__ + "img/cross-white.658a9689.svg";